import fromObjectToKeys from 'utils/converters/object/fromObjectToKeys.util';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

const isFullObject = (value) => {
  // not an object, testing only existing objects
  if (value === null || typeof value !== 'object') return false;

  // arrays *are* objects, and in this case they do hold values, indexed ones
  if (Array.isArray(value) && value.length) return true;

  // the object just needs to have no enumerable keys
  return isPositiveInteger(fromObjectToKeys(value).length);
};

// noinspection JSUnusedGlobalSymbols
export default isFullObject;
